import React from "react";
import { SnackbarProvider } from "notistack";
import { ChargeExternalLink } from "./ChargeExternalLink";
import { Fonts, FontFamilies } from "theme/fontConfig";

export const ChargesLink = () => {
  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={4000}
      style={{ fontFamily: FontFamilies.General, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
    >
      <ChargeExternalLink />
    </SnackbarProvider>
  );
};
